import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const List = ({ className , icon ='default' , spacing ='default' , items , numerical =false , renderText ,  })=>{
    if (items.length < 1) {
        return null;
    }
    const hasIcons = icon !== 'default';
    const hasSmallIcons = icon === null || icon === void 0 ? void 0 : icon.includes('-small');
    const iconSize = hasSmallIcons ? 18 : 24;
    return /*#__PURE__*/ React.createElement("ul", {
        "data-t": "list",
        className: classnames('list', className, {
            'list--with-icons': hasIcons,
            'list--with-small-icons': hasSmallIcons
        })
    }, items.map((item, index)=>/*#__PURE__*/ React.createElement("li", {
            key: item,
            className: classnames('list__item', {
                'list__item--numerical': numerical,
                [`list__item--${icon}`]: !numerical,
                'list__item--compact': spacing === 'compact'
            })
        }, icon !== 'default' && !numerical && /*#__PURE__*/ React.createElement(Icon, {
            name: "checkmark-circle",
            className: "list__item-icon",
            width: iconSize,
            height: iconSize
        }), numerical && /*#__PURE__*/ React.createElement("div", {
            className: "list__item-number"
        }, index + 1), renderText ? renderText(item) : /*#__PURE__*/ React.createElement("span", {
            className: "list__item-text"
        }, item))
    ));
};
List.displayName = 'List';
var List$1 = List;

export { List$1 as default };
//# sourceMappingURL=List.js.map
